import {
  generateBindings,
  ObservableValue,
  useObservedValue,
  view,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-circular-progress';
import { html } from 'lit';

export const [CircularProgress] = view('esui-mwc-circular-progress', {
  Props: class {
    indeterminate: boolean = false;
    progress: number | ObservableValue<number> = 0;
    density = 0;
    closed: boolean | ObservableValue<boolean> = false;
  },

  mapBuilder: CircularProgressBuilder => (progress?: number) => {
    if (typeof progress === 'undefined') {
      return CircularProgressBuilder().indeterminate(true);
    }
    return CircularProgressBuilder().progress(progress);
  },

  template(props) {
    const progress = useObservedValue(props.progress);
    const closed = useObservedValue(props.closed);
    const { density, indeterminate } = props;

    const computedProps = generateBindings({
      indeterminate,
      progress,
      density,
      closed,
    });

    return html`
      <mwc-circular-progress ${spread({ ...computedProps })}>
      </mwc-circular-progress>
    `;
  },
});
